import * as React from 'react';
import { Badge } from './badge';
import { cn } from '@/lib/utils';

export interface TeamBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  colorCode?: string;
}

export function TeamBadge({ name, colorCode, className, ...props }: TeamBadgeProps) {
  if (!name || name === 'Unassigned' || name === 'No team' || name === 'N/A' || name === '—') {
    return (
      <Badge
        variant="outline"
        className={cn('text-xs font-normal bg-muted text-muted-foreground border-none', className)}
        {...props}
      >
        {name || 'No team'}
      </Badge>
    );
  }

  const color = colorCode || '#3B82F6';
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-normal border', className)}
      style={{
        backgroundColor: `${color}1A`,
        color: color,
        borderColor: `${color}33`,
      }}
      {...props}
    >
      {name}
    </Badge>
  );
}
